__turbopack_context__.v({
  "fade-in": "Link-module-scss-module__wKC3Aq__fade-in",
  "link": "Link-module-scss-module__wKC3Aq__link",
  "no-transform": "Link-module-scss-module__wKC3Aq__no-transform",
  "rotate": "Link-module-scss-module__wKC3Aq__rotate",
});
